import React from 'react';
import { Typography } from '@mui/material';
import { useSignup } from '../../context/SignupContext';

interface ProgressIndicatorProps {
  currentStep: number;
}

const ProgressIndicator: React.FC<ProgressIndicatorProps> = ({ currentStep }) => {
  const { account } = useSignup();

  return (
    <Typography  fontWeight="600" marginRight={1}>
      {currentStep}/{account.userType === 'influencer'  ? 4 : account.userType === 'creator' ? 1 : account.userType === 'artist' ? 3 : 6}
    </Typography>
  );
};

export default ProgressIndicator;
